import axios from 'axios';
import authHeader from './auth-header';

const NODE_ENV = process.env.NODE_ENV;
const PROTOCOL = process.env.PROTOCOL || 'http://';
const END_POINT_URL = process.env.END_POINT_URL || window.location.hostname;
const END_POINT_PORT = process.env.END_POINT_PORT || '8080';

const API_URL = NODE_ENV === 'production' ? PROTOCOL + END_POINT_URL + '/api/calendar/' : PROTOCOL + END_POINT_URL + ':' + END_POINT_PORT + '/api/calendar/';

class CalendarService {

  getEventCalendarById(eventId) {
    return axios.get(`${API_URL}event/${eventId}`, eventId);
  };

  getCalendarEventsByUserId(userId) {
    return axios.get(`${API_URL}${userId}`, userId);
  };

  getCalendarEventsByUserIdAndDates(userId, start, end) {
    return axios.get(`${API_URL}${userId}/from/${start}/to/${end}`, userId, start, end);
  };

  getPlayersByEventCalendarId(eventId) {
    return axios.get(`${API_URL}${eventId}/players`, eventId);
  };

  getUsersAssignedByEventCalendarId(eventId) {
    return axios.get(`${API_URL}${eventId}/users`, eventId);
  };

  getPlayersByEventCalendarIds(eventIds) {
    return axios.get(`${API_URL}${eventIds}/board-players`, eventIds);
  };

  getUsersAssignedByEventCalendarIds(eventIds) {
    return axios.get(`${API_URL}${eventIds}/board-users`, eventIds);
  };

  createEvent(event) {
    return axios.post(API_URL, event);
  };

  updateEventCalendar(event) {
    return axios.put(API_URL, event);
  }

  deleteEventCalendar(eventId) {
    return axios.delete(`${API_URL}${eventId}`, eventId);
  };

  getPlayersByGameId(gameId) {
    return axios.get(API_URL + gameId + '/game-players');
  };

}

export default new CalendarService();
